<script>
export default {
  name: "RouteView",
  data() {
    return {};
  },
  render() {
    const notKeep = <router-view />;

    // const keep = (
    //   <keep-alive include="OrderCheckIn">
    //     <router-view />
    //   </keep-alive>
    // );
    // if (this.$route.meta.keepAlive) {
    //   return keep;
    // } else {
    //   return notKeep;
    // }
    // const notKeep = (
    //   <div>
    //     <keep-alive v-if="$route.meta.keepAlive">
    //       {" "}
    //       <router-view />
    //     </keep-alive>{" "}
    //     <router-view v-if="!$route.meta.keepAlive" />
    //   </div>
    // );
    return notKeep;
  },
};
</script>
